import { DECISION_TYPES } from './fixtures';
import type { DecisionStatus, DecisionType, HrDecision } from './types';

// Mint-HRDecision · danh sách (code board khối TABS0 / STL / KP / MASK). Không lương: loại có tiền luôn che nội dung.

export const DECISION_TABS = [
  { key: 'pending', label: 'Chờ duyệt', status: 'Pending' },
  { key: 'approved', label: 'Đã duyệt', status: 'Approved' },
  { key: 'rejected', label: 'Từ chối', status: 'Rejected' },
  { key: 'all', label: 'Tất cả', status: '' },
] as const;
export type DecisionTab = (typeof DECISION_TABS)[number]['key'];

export const DECISION_STATUS: Record<DecisionStatus, { label: string; tone: 'warn' | 'ok' | 'err' | 'mute' }> = {
  Pending: { label: 'Chờ duyệt', tone: 'warn' },
  Approved: { label: 'Đã duyệt', tone: 'ok' },
  Rejected: { label: 'Từ chối', tone: 'err' },
  Draft: { label: 'Nháp', tone: 'mute' },
};

export const DECISION_MASK = '•••••• cần quyền lương';
export const DECISION_COLS: ReadonlyArray<readonly [string, string]> = [
  ['Số QĐ · loại', '27%'], ['Nhân sự · ghế', '22%'], ['Thay đổi (sau)', '27%'], ['Hiệu lực', '12%'], ['Trạng thái', '12%'],
];
export const DECISION_MORE: readonly (readonly [string, string])[] = [
  ['Nạp bộ mẫu văn bản quyết định', 'Tạo 6 mẫu QD-* ở trạng thái Draft'],
  ['Xuất sổ quyết định (Excel)', 'Theo bộ lọc đang chọn'],
  ['Sửa sai số nhập liệu lương', 'Có lý do · nhật ký trước → sau · không phải quyết định'],
];

export const decisionTypeLabel = (t: DecisionType) => DECISION_TYPES.find((x) => x.type === t)?.label ?? t;
export const decisionIsMoney = (t: DecisionType) => DECISION_TYPES.find((x) => x.type === t)?.money ?? false;

/** Nháp tính chung với Chờ duyệt (board: `want === 'Pending'`). */
const inTab = (d: HrDecision, tab: DecisionTab) => {
  const want = DECISION_TABS.find((x) => x.key === tab)?.status ?? '';
  return !want || d.status === want || (want === 'Pending' && d.status === 'Draft');
};

const norm = (x: string) => x.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').toLowerCase();

export function tabCount(ds: readonly HrDecision[], tab: DecisionTab) {
  return ds.filter((d) => inTab(d, tab)).length;
}

export function filterDecisions(ds: readonly HrDecision[], o: { tab: DecisionTab; type: DecisionType | 'all'; q: string }) {
  const q = norm(o.q.trim());
  return ds.filter((d) => inTab(d, o.tab) && (o.type === 'all' || d.type === o.type)
    && (!q || norm([d.no, decisionTypeLabel(d.type), d.user, d.name, d.seat, d.before, d.after].join(' ')).includes(q)));
}

export interface DecisionKpi { k: string; v: string; u: string; tone?: 'warn' | 'ok' }
export function decisionKpis(ds: readonly HrDecision[]): DecisionKpi[] {
  const pend = ds.filter((d) => d.status === 'Pending').length;
  return [
    { k: 'Chờ duyệt', v: String(pend), u: '1 quá 2 ngày LV', tone: pend ? 'warn' : 'ok' },
    { k: 'Hiệu lực 30 ngày tới', v: '6', u: '' },
    { k: 'Đã áp tháng 10', v: '2', u: 'kiêm nhiệm · thư mời' },
    { k: 'Cần bổ sung', v: '3', u: '', tone: 'warn' },
  ];
}

/** Dock phải 1920 (code board khối `tpls`, `soon`). */
export const DECISION_TEMPLATES = [['QD-TANGLUONG', 'Điều chỉnh lương'], ['QD-THANGCAP', 'Thăng cấp'], ['QD-DIEUCHUYEN', 'Điều chuyển'], ['QD-KIEMNHIEM', 'Kiêm nhiệm'], ['QD-BONHIEM', 'Bổ nhiệm'], ['TB-THUMOI', 'Thư mời nhận việc']]
  .map(([c, k]) => ({ code: `${c}-v1.0`, k: k as string }));

export function decisionSoon(ds: readonly HrDecision[]) {
  return ds
    .filter((x) => (x.status === 'Pending' || x.status === 'Approved') && /Oct|Nov/.test(x.effective))
    .slice(0, 5)
    .map((x) => ({ k: `${x.effective} · ${x.user}`, sub: `${decisionTypeLabel(x.type)} · ${DECISION_STATUS[x.status].label}` }));
}
